import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  noSummaryAvailable: {
    id: 'phc-web-toolkit.subjectViewer.executiveSummary.noSummaryAvailable',
    defaultMessage: 'No annual report available',
  },
  generate: {
    id: 'phc-web-toolkit.subjectViewer.executiveSummary.generate',
    defaultMessage: 'Generate Now',
  },
  generateInProgress: {
    id: 'phc-web-toolkit.subjectViewer.executiveSummary.generateInProgress',
    defaultMessage: 'Generating...',
  },
  regenerate: {
    id: 'phc-web-toolkit.subjectViewer.executiveSummary.generate',
    defaultMessage: 'Regenerate',
  },
  regenerateAll: {
    id: 'phc-web-toolkit.subjectViewer.executiveSummary.regenerateAll',
    defaultMessage: 'Regenerate All Sections',
  },
  startNewGeneration: {
    id: 'phc-web-toolkit.subjectViewer.executiveSummary.startNewGeneration',
    defaultMessage: 'Generate New AR',
  },
  regenerateSelected: {
    id: 'phc-web-toolkit.subjectViewer.executiveSummary.regenerateSelected',
    defaultMessage: 'Regenerate {impressionType} Section',
  },
  actionPlanMoved: {
    id: 'phc-web-toolkit.subjectViewer.executiveSummary.actionPlanMoved',
    defaultMessage: 'Action plan has moved to the dedicated action plan page',
  },
  regenerateActionPlan: {
    id: 'phc-web-toolkit.subjectViewer.executiveSummary.regenerateActionPlan',
    defaultMessage: 'Regenerate Action Plan',
  },
  regenerateAlert: {
    id: 'phc-web-toolkit.subjectViewer.executiveSummary.regenerateAlert',
    defaultMessage: 'Edited sections will not be regenerated',
  },
  regenerateAllV2WithInstructions: {
    id: 'phc-web-toolkit.subjectViewer.executiveSummary.regenerateAllV2WithInstructions',
    defaultMessage:
      'Edited sections will be regenerated using provided instructions',
  },
  generateNewAlert: {
    id: 'phc-web-toolkit.subjectViewer.executiveSummary.generateNewAlert',
    defaultMessage:
      'The current annual report is {status}. Only the Action Plan can be modified. Regeneration of action plan for completed reports is coming soon. You can still edit the action plan manually.',
  },
  regenerateInProgress: {
    id: 'phc-web-toolkit.subjectViewer.executiveSummary.regenerateInProgress',
    defaultMessage: 'Regenerating...',
  },
  generateInProgressLong: {
    id: 'phc-web-toolkit.subjectViewer.executiveSummary.generateInProgress',
    defaultMessage:
      'Generating an annual report. This can take up to 15 minutes.',
  },
  generateSuccess: {
    id: 'phc-web-toolkit.subjectViewer.executiveSummary.generateSuccess',
    defaultMessage: 'Annual report generated successfully.',
  },
  generateFailure: {
    id: 'phc-web-toolkit.subjectViewer.executiveSummary.generateFailure',
    defaultMessage: 'Failed to generate annual report. Please notify support.',
  },
  generateConflict: {
    id: 'phc-web-toolkit.subjectViewer.executiveSummary.generateConflict',
    defaultMessage:
      'A generation is already in progress for this member. Please wait for it to complete before regenerating.',
  },
  actions: {
    id: 'phc-web-toolkit.subjectViewer.executiveSummary.actions',
    defaultMessage: 'Actions',
  },
  feedback: {
    id: 'phc-web-toolkit.subjectViewer.executiveSummary.feedback',
    defaultMessage: 'Feedback',
  },
  keyboardShortcuts: {
    id: 'phc-web-toolkit.subjectViewer.executiveSummary.keyboardShortcuts',
    defaultMessage: 'Keyboard Shortcuts',
  },
  placeholderFeedback: {
    id: 'phc-web-toolkit.subjectViewer.executiveSummary.placeholderFeedback',
    defaultMessage:
      'Provide specific feedback on body systems, missing reports, or other issues encountered',
  },
  leaveFeedback: {
    id: 'phc-web-toolkit.subjectViewer.executiveSummary.leaveFeedback',
    defaultMessage: 'Leave Feedback',
  },
  send: {
    id: 'phc-web-toolkit.subjectViewer.executiveSummary.send',
    defaultMessage: 'Send',
  },
  areYouSure: {
    id: 'phc-web-toolkit.subjectViewer.executiveSummary.areYouSure',
    defaultMessage: 'Are you sure?',
  },
  deleteImpression: {
    id: 'phc-web-toolkit.subjectViewer.executiveSummary.deleteImpression',
    defaultMessage:
      'Are you sure you want to delete the "{impressionType}" section? This cannot be undone.',
  },
  deleteImpressionFailure: {
    id: 'phc-web-toolkit.subjectViewer.executiveSummary.deleteImpressionFailure',
    defaultMessage:
      'Failed to delete section. You may not have permission to delete this section. Please notify support.',
  },
  exit: {
    id: 'phc-web-toolkit.subjectViewer.executiveSummary.exit',
    defaultMessage: 'Exit',
  },
  cancel: {
    id: 'phc-web-toolkit.subjectViewer.executiveSummary.cancel',
    defaultMessage: 'Keep Editing',
  },
  confirm: {
    id: 'phc-web-toolkit.subjectViewer.executiveSummary.confirm',
    defaultMessage: 'Yes, Delete',
  },
  pending: {
    id: 'phc-web-toolkit.subjectViewer.executiveSummary.pending',
    defaultMessage: 'Pending',
  },
  scheduled: {
    id: 'phc-web-toolkit.subjectViewer.executiveSummary.scheduled',
    defaultMessage: 'Scheduled',
  },
  processing: {
    id: 'phc-web-toolkit.subjectViewer.executiveSummary.processing',
    defaultMessage: 'Processing',
  },
  completed: {
    id: 'phc-web-toolkit.subjectViewer.executiveSummary.completed',
    defaultMessage: 'Completed',
  },
  scheduledButtonTooltip: {
    id: 'phc-web-toolkit.subjectViewer.executiveSummary.scheduledButtonTooltip',
    defaultMessage:
      'Scheduled generation on {scheduled}, click below button to generate now',
  },
  addActionItem: {
    id: 'phc-web-toolkit.subjectViewer.executiveSummary.actionItem',
    defaultMessage: 'New Action Item',
  },
  editSummary: {
    id: 'phc-web-toolkit.subjectViewer.executiveSummary.editSummary',
    defaultMessage: 'Edit',
  },
  toggleSidebar: {
    id: 'phc-web-toolkit.subjectViewer.executiveSummary.toggleSidebar',
    defaultMessage: 'Toggle Sidebar',
  },
  impressionTypeNotFound: {
    id: 'phc-web-toolkit.subjectViewer.executiveSummary.impressionTypeNotFound',
    defaultMessage:
      'Composite report template does not include the "{impressionType}" section',
  },
  impressionV2Error: {
    id: 'GenerateMenuModal.impressionV2Error',
    defaultMessage:
      'To regenerate this section with its human edits, please specify instructions.',
  },
});

/** these are all rendered as a list in order in the keyboard shortcuts menu */
export const keyboardShortcuts = defineMessages({
  meta: {
    id: 'phc-web-toolkit.subjectViewer.executiveSummary.keyboardShortcuts.meta',
    defaultMessage: '⌘ = command/meta key, ⇧ = shift key',
  },
  presentationMode: {
    id: 'phc-web-toolkit.subjectViewer.executiveSummary.keyboardShortcuts.presentationMode',
    defaultMessage: '⌘ + p: Open presentation mode',
  },
  startEditing: {
    id: 'phc-web-toolkit.subjectViewer.executiveSummary.keyboardShortcuts.startEditing',
    defaultMessage: '⌘ + e: Start editing',
  },
  whenEditing: {
    id: 'phc-web-toolkit.subjectViewer.executiveSummary.keyboardShortcuts.whenEditing',
    defaultMessage: 'When editing:',
  },
  saveAndExitEditMode: {
    id: 'phc-web-toolkit.subjectViewer.executiveSummary.keyboardShortcuts.saveAndExitEditMode',
    defaultMessage: '⌘ + s: Save and exit edit mode',
  },
  saveAndContinueEditing: {
    id: 'phc-web-toolkit.subjectViewer.executiveSummary.keyboardShortcuts.saveAndContinueEditing',
    defaultMessage: '⌘ + ⇧ + s: Save and continue editing',
  },

  bold: {
    id: 'phc-web-toolkit.subjectViewer.executiveSummary.keyboardShortcuts.bold',
    defaultMessage: '⌘ + b: Bold',
  },
  italic: {
    id: 'phc-web-toolkit.subjectViewer.executiveSummary.keyboardShortcuts.italic',
    defaultMessage: '⌘ + i: Italic',
  },
  underline: {
    id: 'phc-web-toolkit.subjectViewer.executiveSummary.keyboardShortcuts.underline',
    defaultMessage: '⌘ + u: Underline',
  },
});
